// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.verificationCode {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
  margin: 2.5rem auto 0;
  padding: 1.75rem 1.5rem;
  text-align: center;
  background-color: #ffffff;
  border-radius: 1.25rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}
.verificationCode__title {
  margin-bottom: 0.35rem;
  color: #222;
  font-weight: 600;
  font-size: 1.2rem;
}
.verificationCode__subtitle {
  margin: 0 0 1.75rem;
  color: #888;
  font-size: 0.88rem;
  line-height: 1.5;
}
.verificationCode .code-inputs {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  width: 100%;
  max-width: 22rem;
  margin: 0 auto;
  gap: 0.5rem;
}
.verificationCode .code-inputs .code-input {
  width: 100%;
  min-width: 0;
  max-width: 2.6rem;
  justify-self: center;
  box-sizing: border-box;
  height: 3.4rem;
  background-color: #f9f9f9;
  border: 1.5px solid #eee;
  border-radius: 0.75rem;
  color: #1a1a1a;
  font-weight: 700;
  font-size: 1.6rem;
  text-align: center;
  caret-color: #515592;
  transition: all 0.2s ease;
}
.verificationCode .code-inputs .code-input:focus {
  outline: none;
  background-color: #ffffff;
  border-color: #515592;
  box-shadow: 0 0 0 4px rgba(81, 85, 146, 0.12);
  transform: translateY(-2px);
}
.verificationCode .code-inputs .code-input:not([value=""]) {
  background-color: #ffffff;
  border-color: #515592;
}
.verificationCode .code-inputs .code-input.error {
  color: #f70d1a;
  background-color: rgba(247, 13, 26, 0.05);
  border-color: #f70d1a;
}
.verificationCode .error-message {
  min-height: 1.2rem;
  margin-top: 1rem;
  color: #f70d1a;
  font-size: 0.85rem;
}

button.verificationCodeBtn {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 3rem);
  background: linear-gradient(to right, #1d2239, #4657a2, #1d2239);
  color: #ffffff;
  border-radius: 2rem;
  border: none;
  text-transform: uppercase;
  font-size: 1.1rem;
  line-height: 1.3rem;
  padding: 1rem 0;
  margin: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 200px;
  height: 3rem;
  margin: 1.5rem auto 0;
  padding: 0;
  background: #515592 !important;
  color: #ffffff;
  font-family: "Roboto", sans-serif !important;
  font-weight: 500 !important;
  font-size: 1.1rem;
  letter-spacing: 0.2px;
  border: none;
  border-radius: 100px;
  box-shadow: 0 6px 20px rgba(81, 85, 146, 0.35);
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none !important;
}
button.verificationCodeBtn:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
button.verificationCodeBtn:disabled {
  background: rgb(200, 200, 200);
}
button.verificationCodeBtn:hover:not(:disabled) {
  filter: brightness(1.05);
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(81, 85, 146, 0.45);
}
button.verificationCodeBtn:active:not(:disabled) {
  filter: brightness(0.95);
  transform: translateY(1px);
  box-shadow: 0 3px 10px rgba(81, 85, 146, 0.2);
}
button.verificationCodeBtn:disabled {
  background: rgb(200, 200, 200) !important;
  color: rgba(255, 255, 255, 0.6);
  box-shadow: none;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/VerificationCode/VerificationCode.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss","webpack://./src/assets/Theme/mixins/_app-button.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAlEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBCbM;EDcN,sBAAA;EACA,2CAAA;AAoEF;AAlEE;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAoEJ;AAjEE;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAmEJ;AAhEE;EACE,aAAA;EACA,gDAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAkEJ;AAhEI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAnDU;EAoDV,yBAAA;AAkEN;AAhEM;EACE,aAAA;EACA,yBC1DA;ED2DA,qBAzDQ;EA0DR,6CAAA;EACA,2BAAA;AAkER;AA/DM;EACE,yBCjEA;EDkEA,qBAhEQ;AAiIhB;AA9DM;EACE,cClEI;EDmEJ,yCAAA;EACA,qBCpEI;ADoIZ;AA3DE;EACE,kBAAA;EACA,gBAAA;EACA,cC5EQ;ED6ER,kBAAA;AA6DJ;;AAzDA;EEpFE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gEDDe;ECEf,cDPM;ECQN,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EF0EA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,8BAAA;EACA,cCjGM;EDkGN,4CAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,8CAAA;EACA,eAAA;EACA,yBAAA;EACA,+BAAA;AAwEF;AEpKE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AFsKJ;AEpKE;EACE,8BDdO;ADoLX;AA9EE;EACE,wBAAA;EACA,2BAAA;EACA,8CAAA;AAgFJ;AA7EE;EACE,wBAAA;EACA,0BAAA;EACA,6CAAA;AA+EJ;AA5EE;EACE,yCAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AA8EJ","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme';\n\n$brand_primary: #515592;\n$inactive_line: #e0e0e0;\n\n.verificationCode {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  position: relative;\n  margin: 2.5rem auto 0;\n  padding: 1.75rem 1.5rem;\n  text-align: center;\n  background-color: $white;\n  border-radius: 1.25rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n\n  &__title {\n    margin-bottom: 0.35rem;\n    color: #222;\n    font-weight: 600;\n    font-size: 1.2rem;\n  }\n\n  &__subtitle {\n    margin: 0 0 1.75rem;\n    color: #888;\n    font-size: 0.88rem;\n    line-height: 1.5;\n  }\n\n  .code-inputs {\n    display: grid;\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    width: 100%;\n    max-width: 22rem;\n    margin: 0 auto;\n    gap: 0.5rem;\n\n    .code-input {\n      width: 100%;\n      min-width: 0;\n      max-width: 2.6rem;\n      justify-self: center;\n      box-sizing: border-box;\n      height: 3.4rem;\n      background-color: #f9f9f9;\n      border: 1.5px solid #eee;\n      border-radius: 0.75rem;\n      color: #1a1a1a;\n      font-weight: 700;\n      font-size: 1.6rem;\n      text-align: center;\n      caret-color: $brand_primary;\n      transition: all 0.2s ease;\n\n      &:focus {\n        outline: none;\n        background-color: $white;\n        border-color: $brand_primary;\n        box-shadow: 0 0 0 4px rgba(81, 85, 146, 0.12);\n        transform: translateY(-2px);\n      }\n\n      &:not([value='']) {\n        background-color: $white;\n        border-color: $brand_primary;\n      }\n\n      &.error {\n        color: $errorText;\n        background-color: rgba($errorText, 0.05);\n        border-color: $errorText;\n      }\n    }\n  }\n\n  .error-message {\n    min-height: 1.2rem;\n    margin-top: 1rem;\n    color: $errorText;\n    font-size: 0.85rem;\n  }\n}\n\nbutton.verificationCodeBtn {\n  @include app-button;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 200px;\n  height: 3rem;\n  margin: 1.5rem auto 0;\n  padding: 0;\n  background: $brand_primary !important;\n  color: $white;\n  font-family: 'Roboto', sans-serif !important;\n  font-weight: 500 !important;\n  font-size: 1.1rem;\n  letter-spacing: 0.2px;\n  border: none;\n  border-radius: 100px;\n  box-shadow: 0 6px 20px rgba(81, 85, 146, 0.35);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: none !important;\n\n  &:hover:not(:disabled) {\n    filter: brightness(1.05);\n    transform: translateY(-1px);\n    box-shadow: 0 8px 25px rgba(81, 85, 146, 0.45);\n  }\n\n  &:active:not(:disabled) {\n    filter: brightness(0.95);\n    transform: translateY(1px);\n    box-shadow: 0 3px 10px rgba(81, 85, 146, 0.2);\n  }\n\n  &:disabled {\n    background: $disabled !important;\n    color: rgba(255, 255, 255, 0.6);\n    box-shadow: none;\n    cursor: not-allowed;\n  }\n}\n","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n","@mixin app-button() {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 3rem);\n  background: $buttonLinearBg;\n  color: $white;\n  border-radius: 2rem;\n  border: none;\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  line-height: 1.3rem;\n  padding: 1rem 0;\n  margin: 1rem 1.5rem;\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n  &:disabled {\n    background: $disabled;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
